<template>
  <div>
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('2')"></h5>
      </legend>
    </div>

    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5 v-html="$store.getters.getTag('3')"></h5>
      </legend>
    </div>

    <form-v2-oicc-scopes-table
      :activity="activity"
      v-if="activity && status"
      :disabled="disabled"
      :status="status"
      :title="$store.getters.getTag('3.1.T')"
      :subtitle="$store.getters.getTag('3.1.S')"
      :footer="$store.getters.getTag('3.1.F')"
    />

    <p class="col-12 mt-4" v-html="$store.getters.getTag('3.I.1')"></p>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";

export default {
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      inputs: {},
    };
  },
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },
    status() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.status.code
        : null;
    },
    disabled() {
      if (["100"].includes(this.status)) {
        return false;
      } else if (["112"].includes(this.status)) {
          if (this.$store.state.accreditation.app.change_scopes) {
            return false;
          } else {
            return true;
          } 
      } else {
        return true;
      }
    },
  },
  created() {
  },
  methods: {},
};
</script>
